export const dashboardNavLinks = [
    {
        name: "send money",
        link: "/exchange"
    },
    {
        name: "open orders",
        link: "/orders"
    },
]